import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  Link,
  Button,
  Box,
  DialogContent,
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { makeStyles } from 'tss-react/mui'
import { CookieBannerAccordion } from './CookieBannerAccordion'

type Props = {
  isOpen: boolean
  setIsOpen: (payload: boolean) => void
  onSubmit: any
}

export function CookieBannerDialog(props: Props) {
  const { isOpen, setIsOpen, onSubmit } = props
  const { t } = useTranslation()
  const { classes } = useStyles()

  const [preferences, setPreferences] = useState({
    analyticsConsentGranted: true,
    adConsentGranted: true,
  })

  return (
    <Dialog open={isOpen} classes={{ container: classes.root }}>
      <DialogTitle className={classes.title}>
        <Typography variant="h5" sx={{ p: '12px', letterSpacing: '0.1em' }}>
          {t('cookiesBanner.cookieBannerTitle')}
        </Typography>
        <IconButton onClick={() => setIsOpen(false)} size="large">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ padding: 1 }}>
          {t('cookiesBanner.bannerDescription')}
          &nbsp;
          <Link
            href={`/${t('cookiesBanner.privacyUrl')}`}
            rel="noreferrer"
            target="_blank"
          >
            {t('cookiesBanner.bannerDescLinkText')}
          </Link>
          {t('cookiesBanner.bannerDescriptionCont')}
        </Typography>

        <Box>
          <CookieBannerAccordion
            title={t('cookiesBanner.requiredCookies')}
            description={t('cookiesBanner.requiredCookiesDesc')}
            isRequired
          />
          <CookieBannerAccordion
            title={t('cookiesBanner.analyticalCookies')}
            description={t('cookiesBanner.analyticalCookiesDesc')}
            value={preferences.analyticsConsentGranted}
            onChange={() =>
              setPreferences((p) => ({
                ...p,
                analyticsConsentGranted: !p.analyticsConsentGranted,
              }))
            }
          />
          <CookieBannerAccordion
            title={t('cookiesBanner.targetingCookies')}
            description={t('cookiesBanner.targetingCookiesDesc')}
            value={preferences.adConsentGranted}
            onChange={() =>
              setPreferences((p) => ({
                ...p,
                adConsentGranted: !p.adConsentGranted,
              }))
            }
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onSubmit()}>
          <Typography>{t('cookiesBanner.acceptAllText')}</Typography>
        </Button>
        <Button onClick={() => onSubmit(preferences)} variant="outlined">
          <Typography>{t('cookiesBanner.savePreferences')}</Typography>
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const useStyles = makeStyles()((theme) => ({
  root: {
    '&:focus': {
      outline: 0,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxHeight: '100%',
      margin: 0,
    },
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('sm')]: {
      padding: '1.125rem',
    },
  },
}))
